import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "../../../examples/Tables/DataTable";
import data from "./JanaTerakhirData";
import Icon from "@mui/material/Icon";
import { useMaterialUIController } from "context";

function JanaTerakhir() {
  const { columns, rows } = data();
  
  // Get user from context to determine which dashboard variant to show
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const isKaunterUser = user?.menu?.toUpperCase() === "KAUNTER" || user?.id_pengguna?.toLowerCase() === "huda";
  
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            {isKaunterUser ? "Terimaan Terakhir Mengikut Zon" : "Jana Terakhir Mengikut Zon"}
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                color: "orange",
                fontWeight: "bold",
                fontSize: 20,
                verticalAlign: "middle",
              }}
            >
              warning
            </Icon>
            <MDTypography
              variant="button"
              fontWeight="regular"
              ml={0.5}
              sx={{
                color: "orange",
                animation: "pulse 2s ease-in-out infinite",
                "@keyframes pulse": {
                  "0%": { opacity: 1 },
                  "50%": { opacity: 0.7 },
                  "100%": { opacity: 1 },
                },
              }}
            >
              {isKaunterUser ? "Semak tarikh terakhir terimaan" : "Semak tarikh terakhir jana"}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
          fontSize={12}
          noPagination
        />
      </MDBox>
    </Card>
  );
}

export default JanaTerakhir;
